import {
  COMPLETED_SLP_LIST_FAILURE,
  COMPLETED_SLP_LIST_PDF_FAILURE,
  COMPLETED_SLP_LIST_PDF_REQUEST,
  COMPLETED_SLP_LIST_PDF_SUCCESS,
  COMPLETED_SLP_LIST_REQUEST,
  COMPLETED_SLP_LIST_SUCCESS,
  PLA_USER_LIST_FAILURE,
  PLA_USER_LIST_REQUEST,
  PLA_USER_LIST_SUCCESS,
  SLP_REQUESTS_FAILURE,
  SLP_REQUESTS_PDF_FAILURE,
  SLP_REQUESTS_PDF_REQUEST,
  SLP_REQUESTS_PDF_SUCCESS,
  SLP_REQUESTS_REQUEST,
  SLP_REQUESTS_SUCCESS,
  UPDATE_SLP_CONTACT_NOTE_FAILURE,
  UPDATE_SLP_CONTACT_NOTE_REQUEST,
  UPDATE_SLP_CONTACT_NOTE_SUCCESS,
  UPDATE_SLP_CONTACT_PROGRESS_FAILURE,
  UPDATE_SLP_CONTACT_PROGRESS_REQUEST,
  UPDATE_SLP_CONTACT_PROGRESS_SUCCESS,
  UPDATE_SLP_PARTICIPATION_FAILURE,
  UPDATE_SLP_PARTICIPATION_REQUEST,
  UPDATE_SLP_PARTICIPATION_SUCCESS,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_FAILURE,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_SUCCESS,
} from "./actionTypes";
import { SLPDashboardActions, SLPDashboardState } from "./type";

const initialState: SLPDashboardState = {
  pending: false,
  slpRequests: [],
  completedSLPs: [],
  userList: [],
  slpRequestPDF: "",
  completedSLPsPDF: "",
  goalsAssessmentPDF: "",
  error: null,
};

const reducer = (
  state = initialState,
  action: SLPDashboardActions
): SLPDashboardState => {
  switch (action.type) {
    case SLP_REQUESTS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case SLP_REQUESTS_SUCCESS:
      return {
        ...state,
        slpRequests: action.payload.slpRequests,
        slpRequestsPagination: action.payload.slpRequestsPagination,
        pending: false,
      };
    case SLP_REQUESTS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case PLA_USER_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case PLA_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: action.payload.userList,
        pending: false,
      };
    case PLA_USER_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case SLP_REQUESTS_PDF_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case SLP_REQUESTS_PDF_SUCCESS:
      return {
        ...state,
        slpRequestPDF: action.payload.slpRequestPDF,
        pending: false,
      };
    case SLP_REQUESTS_PDF_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case UPDATE_SLP_CONTACT_PROGRESS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_SLP_CONTACT_PROGRESS_SUCCESS:
      return {
        ...state,
        contactProgress: action.payload.contactProgress,
        pending: false,
      };
    case UPDATE_SLP_CONTACT_PROGRESS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case COMPLETED_SLP_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case COMPLETED_SLP_LIST_SUCCESS:
      return {
        ...state,
        completedSLPs: action.payload.completedSLPs,
        completedSLPsPagination: action.payload.completedSLPsPagination,
        pending: false,
      };
    case COMPLETED_SLP_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case COMPLETED_SLP_LIST_PDF_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case COMPLETED_SLP_LIST_PDF_SUCCESS:
      return {
        ...state,
        completedSLPsPDF: action.payload.completedSLPsPDF,
        pending: false,
      };
    case COMPLETED_SLP_LIST_PDF_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case UPDATE_SLP_PARTICIPATION_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_SLP_PARTICIPATION_SUCCESS:
      return {
        ...state,
        participation: action.payload.participation,
        pending: false,
      };
    case UPDATE_SLP_PARTICIPATION_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case UPDATE_SLP_CONTACT_NOTE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_SLP_CONTACT_NOTE_SUCCESS:
      return {
        ...state,
        contactNote: action.payload.contactNote,
        pending: false,
      };
    case UPDATE_SLP_CONTACT_NOTE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case VIEW_SLP_GOALS_ASSESSMENT_PDF_SUCCESS:
      return {
        ...state,
        slpRequestPDF: action.payload.goalsAssessmentPDF,
        pending: false,
      };
    case VIEW_SLP_GOALS_ASSESSMENT_PDF_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
